"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const react_leaflet_1 = require("react-leaflet");
const leaflet_1 = __importDefault(require("leaflet"));
require("leaflet/dist/leaflet.css");
const marker_icon_png_1 = __importDefault(require("leaflet/dist/images/marker-icon.png"));
const marker_shadow_png_1 = __importDefault(require("leaflet/dist/images/marker-shadow.png"));
const utils_1 = require("./../utils");
const defaultCentre = {
    lat: utils_1.DEFAULT_MAP_CENTRE.lat,
    lng: utils_1.DEFAULT_MAP_CENTRE.lng,
};
if (typeof window !== 'undefined') {
    const DefaultIcon = leaflet_1.default.icon({
        iconUrl: marker_icon_png_1.default,
        shadowUrl: marker_shadow_png_1.default,
        iconSize: [25, 40],
        iconAnchor: [12, 40],
    });
    leaflet_1.default.Marker.prototype.options.icon = DefaultIcon;
}
const MapCentre = (props) => {
    const map = (0, react_leaflet_1.useMap)();
    const { coordinates, zoom } = props;
    (0, react_1.useEffect)(() => {
        if (coordinates.length === 0) {
            return;
        }
        if (coordinates.length > 1) {
            map.fitBounds(coordinates);
        }
        else {
            map.setZoom(zoom);
            map.panTo(coordinates[0]);
        }
    }, [coordinates]);
    return null;
};
const Map = (props) => {
    const { coordinates, zoom } = props;
    const theme = (0, styles_1.useTheme)();
    const [marker, setMarker] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setMarker(coordinates.length === 1 ? coordinates[0] : undefined);
    }, [coordinates]);
    if (typeof window === 'undefined') {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_leaflet_1.MapContainer, { style: { height: '100%', width: '100%' }, id: 'mapid', center: defaultCentre, zoom: zoom, className: "z-10", whenCreated: (map) => {
            if (props.onLoad) {
                props.onLoad(map);
            }
        } },
        react_1.default.createElement(react_leaflet_1.TileLayer, { attribution: '\u00A9 <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
        marker && react_1.default.createElement(react_leaflet_1.Marker, { position: marker }),
        coordinates.length > 0 && (react_1.default.createElement(react_leaflet_1.Polygon, { positions: coordinates, pathOptions: {
                color: theme.palette.primary.main,
                fillColor: 'transparent',
            } })),
        react_1.default.createElement(MapCentre, { coordinates: coordinates, zoom: zoom })));
};
Map.defaultProps = {
    coordinates: [],
    zoom: 12,
};
Map.propTypes = {
    onLoad: prop_types_1.default.func,
    coordinates: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        lat: prop_types_1.default.number,
        lng: prop_types_1.default.number,
    })),
    zoom: prop_types_1.default.number,
};
exports.default = Map;
